import { store } from '@/app/store';
import { favouriteMessage, getFavouriteMessages } from '@/infrastructure/sdk/message';
import { getUserIdFromJid } from '@/shared/utils';
import { addStarredMessage, removeStarredMessage, setStarredMessages } from '../model';
import { updateMessageFavouriteStatus } from '../model/conversation/reducer';
import { formatUserIdToJid } from './jidIdFormat';

export const normalizeStarredMessage = msg => {
   // publisherId (List response) or fromUserId (Real-time) is the actual sender
   const trueSenderId = msg.publisherId || msg.fromUserId || getUserIdFromJid(msg.fromUserJid);
   // userJid (Real-time) or fromUserJid (List response) is the chat partner
   const chatPartnerJid = msg.userJid || (msg.publisherId ? msg.fromUserJid : msg.chatJid);

   return {
      ...msg,
      msgId: msg.msgId || msg.messageId,
      msgType: msg.msgBody?.message_type || msg.msgType || 'text',
      fromUserId: trueSenderId,
      deleteStatus: msg.deleteStatus || 0,
      chatJid: msg.chatJid || formatUserIdToJid(chatPartnerJid, msg.chatType),
   };
};

export const fetchStarredMessages = async () => {
   try {
      const res = await getFavouriteMessages();
      const content = Array.isArray(res) ? res : res?.data;

      if (Array.isArray(content)) {
         const normalized = content.map(normalizeStarredMessage);
         store.dispatch(setStarredMessages(normalized));
      }
   } catch (error) {
      console.error('[StarredMessages] Failed to fetch:', error);
   }
};

export const toggleStarMessage = async (messageOrMessages, chatJid) => {
   const messagesArray = Array.isArray(messageOrMessages) ? messageOrMessages : [messageOrMessages];
   const chatId = getUserIdFromJid(chatJid);

   // If every message is already starred → unstar all; otherwise → star all
   const isFavourite = !messagesArray.every(m => m.favouriteStatus === 1);
   const numericStatus = isFavourite ? 1 : 0;
   const msgIds = messagesArray.map(m => m.msgId || m.messageId);

   try {
      const response = await favouriteMessage(chatJid, msgIds, isFavourite);
      if (response?.statusCode !== 200) return;

      for (const message of messagesArray) {
         const msgId = message.msgId;
         const starAction = isFavourite
            ? addStarredMessage(normalizeStarredMessage({ ...message, favouriteStatus: 1 }))
            : removeStarredMessage(msgId);

         store.dispatch(starAction);
         store.dispatch(updateMessageFavouriteStatus({ chatId, msgId, favouriteStatus: numericStatus }));
      }
   } catch (error) {
      console.error('[StarredMessages] Failed to toggle star:', error);
   }
};
